export const cloneImmutableArray = <T>(items: T[]): T[] => {
    return ([] as T[]).concat(items);
};
